import { type UseQueryResult, useQuery } from 'react-query';
import {
  DashboardService,
  // eslint-disable-next-line camelcase
  type Wealthlane_AwardService_Dtos_MyHoldings_DashboardVestingScheduleDto,
} from '@wealthlane/api-services/wealthlane-award-service';

const useGetDashboardVestingSummary = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  // eslint-disable-next-line camelcase
  Array<Wealthlane_AwardService_Dtos_MyHoldings_DashboardVestingScheduleDto> | undefined,
  unknown
> => {
  const dashboardVestingSummary = useQuery(['getDashboardVestingSummary'], async () => {
    // Add 10 second delay
    await new Promise((resolve) => setTimeout(resolve, 5000));
    return await handleRequest(DashboardService.getApiAwardApiAppDashboardVestingSummary());
  });

  return dashboardVestingSummary;
};

export default useGetDashboardVestingSummary;
